import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { SelectBoxStore } from '../../stores/SelectBoxStore';
import { PconLoginStore } from '../../stores/PconLoginStore';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { SelectionDataLanguage } from '../SelectionDataLanguage';
import { SelectionUnitOfMeasurement } from '../SelectionUnitOfMeasurement';
import { SelectionCurrency } from '../SelectionCurrency';
import { SelectionPrice } from '../SelectionPrice';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { UICoreButton } from '../UICoreButton';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { SelectionLanguage } from '../SelectionLanguage';
import { SelectionSidebarOrientation } from '../SelectionSidebarOrientation';
import { SelectionImageFormat } from '../SelectionImageFormat';
import { LayoutType } from '../../constants/LayoutConstants';

interface SettingTabState {
    hidden: boolean;
    pricesEnabled: boolean;
}

export class SettingTab extends BaseHamburgerTab<SettingTabState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(SelectBoxStore, this.onChange); // to hide tab in core-app-layout
        this.addStoreListener(PconLoginStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null  {
        if (this.state.hidden) {
            return null;
        }
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                <div className="hamburger-subheader">{t('Project settings')}</div>
                <SelectionDataLanguage/>
                <SelectionUnitOfMeasurement/>
                <SelectionCurrency/>
                <SelectionPrice/>
                {
                    AppConfigurationStore.getState().twoStepSettingSaving ?
                        <UICoreButton onClick={ProjectSettingsActions.saveSettings} color="light-grey" align="right" label={t('Save as default')}/> :
                        null
                }
                <br/>
                <div className="hamburger-subheader">{t('User Interface')}</div>
                <SelectionLanguage/>
                <SelectionSidebarOrientation/>
                <SelectionImageFormat/>
            </HamburgerContentWrapper>
        );
    }

    protected onChange = (): void => {
        this.setState({
            hidden: (SelectBoxStore.getState().options.length > 0 && !SelectBoxStore.getState().asOverlay) && this.props.layoutType !== LayoutType.DESKTOP,
            pricesEnabled: PconLoginStore.pricesEnabled()
        });
    };

    protected getLabel(): string {
        return t('Settings');
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/SettingTab.tsx